import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NavigationEnd, Router } from '@angular/router';
import { AuthServiceService } from 'app/Authentification/auth-service.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputOtpModule } from 'primeng/inputotp';
import { ToastModule } from 'primeng/toast';
import { first } from 'rxjs';

@Component({
  selector: 'app-new-password',
  imports: [ReactiveFormsModule, ConfirmDialogModule,
    MatCardModule, MatFormFieldModule, MatInputModule, ToastModule,
    InputOtpModule, FormsModule, ButtonModule],
  templateUrl: './new-password.html',
  styleUrl: './new-password.scss',
})
export class NewPassword {

  passwordForm!: FormGroup;
  showNewPassword = false;
  showConfirmPassword = false;
  error: string = "";
  loading: any;


  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authenticationService: AuthServiceService,
    public urlsService: UrlsService,
    private userService:UserService,
    public constantService: ConstantService,
    public confirmationService: ConfirmationService,
    private messageService: MessageService) {

  }

  ngOnInit() {
    this.passwordForm = this.fb.group(
      {
        newPassword: [
          '',
          [
            Validators.required,
            Validators.pattern(ConstantService.passwordRegex),
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      { validators: this.passwordMatchValidator }
    );
  }

  passwordMatchValidator(form: FormGroup) {
    const password = form.get('newPassword')?.value;
    const confirm = form.get('confirmPassword')?.value;

    return password === confirm ? null : { passwordMismatch: true };
  }

  toggleNewPassword() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  onSubmit() {
    if (this.passwordForm.valid) {
      this.setNewPassword(this.passwordForm.value);
    }
  }

  setNewPassword(e: { newPassword: string; newpassword: string; }) {
    this.error = "";
    if (!this.loading) {
      let payload = {
        "username": this.constantService.user.email,
        "session": this.authenticationService.session,
        "newPassword": e.newPassword?.trim(),
      }
      this.loading = true;

      this.authenticationService.setNewPassword(payload)
        .pipe(first())
        .subscribe({
          next: (result: any) => {
            this.loading = false;

            if (result?.success === true) {

              if (result?.tokens) {
                this.constantService.user.password = e.newpassword;
                this.error = "Password Updated, Please login again."
                this.messageService.add({ severity: 'success', summary: 'Success Message', detail: this.error });
              } else {
                this.error = "Failed to reset new password.";
              }

            }
            if (result?.step === "EMAIL_OTP") {
              this.authenticationService.session = result?.session;
              this.router.navigate(['/login/verify-otp']);
            }else{
            this.router.navigate(['/login']);
            }
          },

          error: (err: HttpErrorResponse) => {
            this.loading = false;
            if (err.status === 400) {
              this.error = "Invalid Session.";
            } else if (err.status === 401) {
              this.error = "Session expired. Please try again.";
            } else {
              this.error = err?.error?.message || "Something went wrong.";
            }
            this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: this.error });
          }
        });
    }
  }

}
